import React from "react";
import InfoIcon from "material-ui-icons/Info";

interface BlueRibbonProps {
    text: string;
    color?: string;
}

const BlueRibbon = (props: BlueRibbonProps) => {
    return (
        <div
            className="info-notice-container"
            style={{ backgroundColor: props.color }}
        >
            <div style={{ float: "left", height: "100%" }}>
                <InfoIcon style={{ width: 36, height: 36 }} />
            </div>
            <div className="info-notice-text">{props.text}</div>
        </div>
    );
};

export default BlueRibbon;



// WEBPACK FOOTER //
// ./src/components/BlueRibbon/BlueRibbon.tsx